import type { OrgDepartment, OrgStructure } from '../../api/org';
import { Icon } from '../../components/Icon';

interface Props {
  structure: OrgStructure;
  byId: Map<string, OrgDepartment>;
  expanded: Set<string>;
  onToggle: (id: string) => void;
  onOpenInChart: (id: string) => void;
}

/** Подразделения таблицей с раскрытием ветвей. */
export function OrgTable({ structure, byId, expanded, onToggle, onOpenInChart }: Props) {
  const rows: { department: OrgDepartment; level: number }[] = [];
  const walk = (ids: string[], level: number) => {
    for (const id of ids) {
      const department = byId.get(id);
      if (!department) continue;
      rows.push({ department, level });
      if (expanded.has(id)) walk(department.childIds, level + 1);
    }
  };
  walk(structure.rootIds, 0);

  return (
    <section className="panel">
      <div className="table-scroll">
        <table>
          <thead>
            <tr>
              <th>Подразделение</th>
              <th>Руководитель</th>
              <th className="number">Всего</th>
              <th className="number">Напрямую</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(({ department, level }) => {
              const open = expanded.has(department.id);
              return (
                <tr key={department.id}>
                  <td>
                    <div className="tree-name" style={{ paddingLeft: level * 18 }}>
                      {department.childIds.length ? (
                        <button
                          type="button"
                          className="tree-toggle"
                          aria-expanded={open}
                          aria-label={open ? 'Свернуть' : 'Раскрыть'}
                          onClick={() => onToggle(department.id)}
                        >
                          <Icon name={open ? 'minus' : 'plus'} size={13} />
                        </button>
                      ) : (
                        <span className="tree-spacer" />
                      )}
                      <button type="button" className="link" onClick={() => onOpenInChart(department.id)}>
                        {department.name}
                      </button>
                    </div>
                  </td>
                  <td>
                    {department.heads.length ? (
                      department.heads.map((head) => (
                        <strong key={head.id}>{structure.people[head.id]?.fullName}</strong>
                      ))
                    ) : (
                      <span className="status status-bad">Без руководителя</span>
                    )}
                  </td>
                  <td className="number">{department.totalCount}</td>
                  <td className="number">{department.directCount}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}
